import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { HighlightService } from '../../services/highlight.service';

@Component({
    selector: 'app-code-system-label',
    templateUrl: './code-system-label.component.html',
    styleUrls: ['./code-system-label.component.scss']
})
export class CodeSystemLabelComponent implements OnInit, OnDestroy {
  private highlightService = inject(HighlightService);


  @Input()
  public codeSystem: string;

  public shouldHighlight = false;

  private highlightSubscription: Subscription;

  ngOnInit(): void {
    this.highlightSubscription = this.highlightService.codeSystem$
      .subscribe(codeSystem => this.shouldHighlight = this.codeSystem === codeSystem);
  }

  ngOnDestroy(): void {
    this.highlightSubscription.unsubscribe();
  }

  onMouseEnter(): void {
    this.highlightService.startHighlightingCodeSystem(this.codeSystem);
  }

  onMouseLeave(): void {
    this.highlightService.stopHighlightingCodeSystem();
  }
}
